import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';

// actions and utils
import { allowNav } from '../../../../../utils/allow-nav';
import { getRoutes } from '../../../../../utils/form';

// components
import { CallStatus } from '../../telephony';

function PreviousButton({ currentSection, currentPage }) {
  const navigate = useNavigate();
  const {
    form: { form, baseRoute },
    theme: { allowNavOnlyInCall },
    telephony: { status: callStatus },
    enrollment: { submittedFlag },
  } = useSelector(store => store);

  let disabled = false;
  let prevRoute = '';

  // determine what the next route is from form json config
  form.forEach((section, is) => {
    if (section.route === currentSection) {
      section.pages.forEach((page, ip) => {
        if (page.route === currentPage) {
          if (section.pages[ip - 1]) {
            prevRoute = `/enroll${baseRoute}${currentSection}${section.pages[ip - 1].route}`;
          } else if (!disabled) {
            try {
              const prevSection = form[is - 1];
              const prevPage = prevSection.pages[prevSection.pages.length - 1];
              prevRoute = `/enroll${baseRoute}${prevSection.route}${prevPage.route}`;
            } catch {
              disabled = true;
            }
          }
        }
      });
    }
  });

  const an = allowNav({ allowNavOnlyInCall, submitted: submittedFlag, callStatus });
  if (!an && !prevRoute.includes('telephony')) {
    disabled = true;
  }

  return (
    <button
      type="button"
      className="btn btn-link btn-p"
      disabled={disabled}
      onClick={() => navigate(prevRoute)}
    >
      Previous
    </button>
  );
}

function NextButton({ currentSection, currentPage }) {
  const navigate = useNavigate();
  const {
    form: { form, baseRoute },
    theme: { allowNavOnlyInCall },
    telephony: { status: callStatus },
    enrollment: { submittedFlag },
  } = useSelector(store => store);

  let disabled = false;
  let nextRoute = '';

  // determine what the next route is from form json config
  form.forEach((section, is) => {
    if (section.route === currentSection) {
      section.pages.forEach((page, ip) => {
        if (page.route === currentPage) {
          if (section.pages[ip + 1]) {
            const nextPage = section.pages[ip + 1];
            nextRoute = `/enroll${baseRoute}${currentSection}${nextPage.route}`;
          } else if (!disabled) {
            try {
              const nextSection = form[is + 1];
              const nextPage = form[is + 1].pages[0];
              nextRoute = `/enroll${baseRoute}${nextSection.route}${nextPage.route}`;
            } catch {
              disabled = true;
            }
          }
        }
      });
    }
  });

  const an = allowNav({ allowNavOnlyInCall, submitted: submittedFlag, callStatus });
  if (!an && !nextRoute.includes('telephony')) {
    disabled = true;
  }

  return (
    <button
      type="button"
      className="btn btn-primary btn-p fw-bold"
      disabled={disabled}
      onClick={() => navigate(nextRoute)}
    >
      Next
      <FontAwesomeIcon className="ms-2" icon={faAngleRight} />
    </button>
  );
}

function SaveButton() {
  const dispatch = useDispatch();

  return (
    <button
      type="button"
      className="btn btn-danger btn-p fw-bold"
      style={{ color: 'white' }}
      onClick={() => dispatch({ type: 'OPEN_MODAL', modal: 'exitModal' })}
    >
      Save and Exit
    </button>
  );
}

/*
function Divider() {
  return (
    <div className="d-flex col-auto align-items-center">
      <div className="row">
        <div
          className="d-flex col-auto align-items-center fs-3"
          style={{ color: 'var(--bs-gray-400)' }}
        >
          |
        </div>
      </div>
    </div>
  );
}
*/

function BottomNav() {
  const location = useLocation();
  const { currentSection, currentPage } = getRoutes(location);
  const {
    telephony: { error: callError = 'this is an error' },
  } = useSelector(store => store);


  return (
    <>
      <div className="d-flex col-4">
        <div className="row">
          <div className="ms-4 col-auto">
            <PreviousButton
              currentSection={currentSection}
              currentPage={currentPage}
            />
          </div>
          <div className="col-auto">
            <NextButton
              currentSection={currentSection}
              currentPage={currentPage}
            />
          </div>
        </div>
      </div>

      {/* <Divider /> */}

      <div className="d-flex col-5 ps-5">
        <div className="row">
          <div className="d-flex col-auto align-items-center">
            <CallStatus />
          </div>
          <div className="d-flex col-auto align-items-center">
            <span className="text-danger">{callError}</span>
          </div>
        </div>
      </div>

      {/* <Divider /> */}

      <div className="d-flex col-3 justify-content-end align-items-center">
        <SaveButton />
      </div>
    </>
  );
}

export default BottomNav;
